;(function($, undefined){
    'use strict';

    var rnn = window.rnn,
        log = rnn.logging.log,
        maps;

    function killPopover($map) {
        var mapData = $map.data(),
            popover = mapData.popover,
            gmap = mapData.map;

        popover && gmap.removeOverlay(popover);
    }

    function createAddressChangedEvent(target, results) {
        var event = $.Event('addresschanged');
        event.target = target.jquery && target[0] || target;
        event.address = results;
        return event;
    }

    function createLocationChangedEvent(target, markerPosition) {
        var event = $.Event('locationchanged');
        event.target = target.jquery && target[0] || target;
        event.location = {
            latitude: markerPosition.lat(),
            longitude: markerPosition.lng()
        };
        return event
    }

    function createNoResultsEvent(target) {
        var event = $.Event('noresults');
        event.target = target.jquery && target[0] || target;
        return event;
    }

    function updateMarkerFromAddress(event) {
        var address = event.address,
            $map = $(event.target).closest(".mapArea").find(".map");

        if (!address){
            resetMap($map);
            return;
        }

        function geocodeCallback(results) {
            if (!results) {
                $map.trigger(createNoResultsEvent(event.target));
            } else {
                var position = results[0].geometry.location,
                    mapData = $map.data(),
                    gmap = mapData.map,
                    marker = mapData.marker;

                //log("Google found: "+results[0].formatted_address);

                killPopover($map);
                marker.setPosition(position);
                gmap.map.panTo(position);
                mapData.markerPosition = position;
                $map.trigger(createLocationChangedEvent($map, position));
            }
        }

        maps.geocode({
            address: address,
            callback: geocodeCallback
        });
    }

    function updateMarkerFromLocation($map, location) {

        if (!location){
            resetMap($map);
            return;
        }

        var mapData = $map.data(),
            gmap = mapData.map,
            marker = mapData.marker,
            markerPosition = mapData.markerPosition,
            position = new google.maps.LatLng(location.coords.latitude, location.coords.longitude);

        killPopover($map);

        marker.setPosition(position);
        mapData.markerPosition = position;
        gmap.map.panTo(position);
        $map.trigger(createLocationChangedEvent($map, position));
    }

    function revertMarkerPosition($map) {
        var mapData = $map.data(),
            gmap = mapData.map,
            marker = mapData.marker,
            markerPosition = mapData.markerPosition;

        marker.setPosition(markerPosition);
        gmap.map.panTo(markerPosition);
    }

    function dragEnd($map) {
        var mapData = $map.data(),
            gmap = mapData.map,
            marker = mapData.marker,
            markerPosition = marker.getPosition();

        function geocodeCallback(results) {
            if (!results) {
                revertMarkerPosition($map);
            } else {
                mapData.markerPosition = markerPosition;
                gmap.map.panTo(markerPosition);
                $map.trigger(createAddressChangedEvent($map, results));
                $map.trigger(createLocationChangedEvent($map, markerPosition));
            }
        }

        maps.geocode({
            lat: markerPosition.lat(),
            lng: markerPosition.lng(),
            callback: geocodeCallback
        });
    }

    function resetMap($map) {
        var mapData = $map.data(),
            gmap = mapData.map,
            marker = mapData.marker;

        mapData.marker.setPosition(mapData.initialMarkerPosition);
        mapData.popover = maps.createPopover(gmap, marker);

        gmap.map.setZoom(13);
        gmap.map.panTo(marker.getPosition());
        gmap.map.panBy(0, -32);
    }

    function createLocationPickerMap(mapElement){
        var $map = $(mapElement),
            mapData = $map.data(),
            $mapArea = $map.closest('.mapArea'),
            gmap,
            defaults,
            markerData,
            marker;

        //Location Picker Specific Functions

        // A form fired an addresschanged event
        $mapArea.on('addresschanged', function(event){
            if(!$(event.target).closest($map).length){ //We dont want to listen to our own events!
                updateMarkerFromAddress(event);
            }
        }).on('locationchanged', function(event){
            if(!$(event.target).closest($map).length){ //We dont want to listen to our own events!
                updateMarkerFromLocation($map, event.location);
            }
        });

        defaults = _.defaults(mapData && mapData.mapConfig || {}, {
            div: $map[0],
            zoom: 13,
            disableDefaultUI: true,
            zoomControl: true
        });

        // Create the map UI control
        gmap = maps.createMap(defaults);

        // Add marker & popover to the map UI
        markerData = mapData.mapMarker = mapData.mapMarker || {};
        marker = maps.addMarkerToMap(gmap, {
            lat: markerData.latitude || gmap.getCenter().lat(),
            lng: markerData.longitude || gmap.getCenter().lng(),
            icon: maps.getDefaults().markers.small.blue.icon,
            draggable: true,
            dragstart: function(){
                killPopover($map);
            },
            dragend: function(){
                dragEnd($map);
            }
        });

        mapData.map = gmap;
        mapData.markerData = markerData;
        mapData.marker = marker;
        mapData.initialMarkerPosition = mapData.markerPosition = marker.getPosition();

        resetMap($map);
    }

    function initLocationPickerMap(){
        maps = rnn.modules.maps
        maps.createLocationPickerMap = createLocationPickerMap;
    }

    rnn.modules.register('locationPickerMap', {
        init: initLocationPickerMap
    });

})(jQuery);
